import { Controller } from "@hotwired/stimulus"
import { reapplyAlternatingRows } from "../js/alternating_rows"

export default class extends Controller {
  toggle() {
    this.element.classList.toggle('expanded')
    reapplyAlternatingRows()
  }
}
